import { createContext } from "react";

export const AuthUrlContext = createContext();
